import { useEffect, useRef, useState } from 'react';
import ListItem from '../List/ListItem';
import { DropdownStylesSettings } from './DropdownStyles';
import DropdownText from './DropdownText';
import { ReactComponent as ChevronDown } from '../../sf-components/Icons/Chevron_down.svg';
import { ReactComponent as ChevronUp } from '../../sf-components/Icons/Chevron_up.svg';

const Dropdown = ({
    options,
    currentOption,
    defaultValue,
    onOptionChange,
    dropdownStyle,
    menuClassName = '',
    labelClassName = '',
    IconLeft,
    iconSize = '16px',
    disabled
}) => {
    const style = DropdownStylesSettings[dropdownStyle] || DropdownStylesSettings.Default;
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);
    const isOptionSelected = currentOption !== defaultValue;

    const calcBordersStyle = () => {
        let borderStr = '';
        if (style.border) {
            borderStr = `border border-${style.border}`;
        }

        if (style.borderHover) {
            borderStr += ` hover:border-${style.borderHover}`;
        }

        if (style.borderFocus) {
            borderStr += ` focus:border-${style.borderFocus}`;
        }

        if (isOptionSelected) {
            borderStr += ` border-${style.borderActive}`;
            if (style.borderHoverActive) borderStr += ` hover:border-${style.borderHoverActive}`;
            if (style.borderFocusActive) borderStr += ` focus:border-${style.borderFocusActive}`;
        }

        return borderStr;
    };

    const calcDropdownStyle = () => {
        let styleStr = `${calcBordersStyle()} bg-${style.background} hover:bg-${style.backgroundHover}  text-${
            style.color
        }`;

        if (isOptionSelected) {
            styleStr = `${calcBordersStyle()} bg-${style.backgroundActive} hover:bg-${style.backgroundActive}  text-${
                style.color
            }`;
        }

        if (disabled) {
            styleStr = `bg-${style.backgroundDisabled} text-${style.colorDisabled}
                 ${style.borderDisabled ? `border border-${style.borderDisabled}` : ''}`;
        }

        return styleStr;
    };

    const handleOpenMenu = (e) => {
        e.preventDefault();
        if (!open) {
            setOpen(true);
        } else handleCloseMenu(e, open);
    };

    const handleCloseMenu = (e) => {
        if (open && !menuRef.current?.contains(e?.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleCloseMenu);
        return () => document.removeEventListener('click', handleCloseMenu);
    }, [open]);

    return (
        <div className="relative">
            <button
                onClick={disabled ? () => {} : handleOpenMenu}
                className={`select-none font-sf w-50 px-3 ${calcDropdownStyle()} ${
                    disabled ? 'cursor-not-allowed' : 'cursor-pointer'
                } transition ease-out duration-300 flex items-center rounded-lg text-13 h-10 font-medium ${labelClassName}`}>
                <DropdownText
                    value={Object.values(options).find((option) => option.value === currentOption)?.label}
                    IconRight={open ? ChevronUp : ChevronDown}
                    IconLeft={IconLeft}
                    chipStyle={dropdownStyle}
                    disabled={disabled}
                    iconSize={iconSize}
                />
            </button>
            {open && (
                <div
                    ref={menuRef}
                    className={`rounded-lg absolute z-20 shadow-sf-medium bg-white w-50 mt-1 ${menuClassName}`}>
                    <div className={`rounded-lg flex flex-col p-2 ${menuClassName}`}>
                        {Object.values(options).map((option, i) => {
                            return (
                                <ListItem
                                    key={i}
                                    selected={option.value === currentOption}
                                    value={option.value}
                                    label={option.label}
                                    onClick={(option) => {
                                        onOptionChange(option);
                                        setOpen(false);
                                    }}
                                />
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dropdown;
